import { render } from "./EditShipyard.vue?vue&type=template&id=8051b6ae"
import script from "./EditShipyard.vue?vue&type=script&lang=ts"
export * from "./EditShipyard.vue?vue&type=script&lang=ts"
script.render = render

export default script